import React from "react";
import { Button, TextField } from "@vitalsource/vstui";
import { createThemedComponent } from "@vitalsource/vstui/themes";
import styled, { withTheme } from "styled-components";

const Flex = styled.div`
  display: flex;
  align-items: flex-end;
`;

const StyledButton = styled(
  createThemedComponent(Button, props => {
    const radius = props.theme.vstui.shape.borderRadius;
    return {
      Button_borderRadius: `0 ${radius} ${radius} 0`
    };
  })
)`
  margin: 5px 0;
`;

const RevealedCode = styled(
  createThemedComponent(TextField, props => {
    // This isn't implemented
    const radius = props.theme.vstui.shape.borderRadius;
    return {
      TextField_borderRadius: `0 ${radius} ${radius} 0`
    };
  })
)`
  margin: 0;
  & > input {
    border-radius: ${props => {
      const radius = props.theme.vstui.shape.borderRadius;
      return `${radius} 0 0 ${radius}`;
    }};
  }
`;

const InputButton = ({ inputProps, buttonProps, children }) => (
  <Flex>
    <RevealedCode {...inputProps} fullWidth />
    <StyledButton {...buttonProps}>{children}</StyledButton>
  </Flex>
);

export default withTheme(InputButton);
